export type Attributes = { [key: string]: any };

export default function featureFlagAttributes(attributes: Attributes) {
  const match = location.host.match(/^\d+/);
  if (match) return { ...attributes, pr: match[0] };
  return attributes;
}
